import React from 'react'
import { LearnMoreExerciseCardProps } from '../index'
import { FeaturedLearnMoreExerciseCard } from './FeaturedLearnMoreExerciseCard'

export const LearnMoreExerciseCard = ({
    imageURL,
    title,
    subTitle,
    featured = false
}: LearnMoreExerciseCardProps) => {
    if (featured) {
        return <FeaturedLearnMoreExerciseCard />
    }
    return (
        <div>
            <div className="flex flex-col rounded-2xl drop-shadow-lg relative bg-gradient-to-r from-purple-400 to-pink-300 mr-3 px-3 h-[460px]">
                <div className="pt-2 max-w-max">
                    <img
                        className="rounded-2xl"
                        alt={'Learn More Fitness Exercises'}
                        src={imageURL}
                    />
                </div>
                <div className="absolute bottom-0 left-0 bg-white rounded-2xl h-1/3">
                    <div className="">
                        <p className="text-md font-medium text-yf-purple px-4 pt-2 z-10 mt-2">
                            {title}
                        </p>
                        <p className="text-xs text-black px-4 z-10">
                            <div dangerouslySetInnerHTML={{ __html: subTitle }}></div>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
